import React from 'react';
import { MapPin, Database, BarChart3, User, Smartphone, ShieldCheck, BookOpen, Share2, Shield, LogOut, Building } from 'lucide-react';

export default function Navbar({
  activeTab,
  setActiveTab,
  currentUser,
  onLogout,
  impersonatedTenantName,
  onClearImpersonate
}) {
  const isAdmin = currentUser?.role === 'admin';

  return (
    <header className="app-header">
      <div className="brand-logo" style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="/brand/loops_side_white_cropped.png"
          alt="Loops Logo"
          style={{ height: '36px', width: 'auto', objectFit: 'contain', display: 'block' }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/brand/Loops Side White.png";
          }}
        />
      </div>

      <nav className="nav-tabs">
        <button
          className={`nav-tab ${activeTab === 'expedition' ? 'active' : ''}`}
          onClick={() => setActiveTab('expedition')}
        >
          <MapPin size={16} />
          <span>Expédition</span>
        </button>

        <button
          className={`nav-tab ${activeTab === 'database' ? 'active' : ''}`}
          onClick={() => setActiveTab('database')}
        >
          <Database size={16} />
          <span>Database</span>
        </button>

        <button
          className={`nav-tab ${activeTab === 'analytics' ? 'active' : ''}`}
          onClick={() => setActiveTab('analytics')}
        >
          <BarChart3 size={16} />
          <span>Analyse</span>
        </button>

        <button
          className={`nav-tab ${activeTab === 'connect' ? 'active' : ''}`}
          onClick={() => setActiveTab('connect')}
        >
          <Share2 size={16} />
          <span>Connect</span>
        </button>

        <button
          className={`nav-tab ${activeTab === 'profile' ? 'active' : ''}`}
          onClick={() => setActiveTab('profile')}
        >
          <User size={16} />
          <span>Compte</span>
        </button>

        {isAdmin && (
          <button
            className={`nav-tab ${activeTab === 'admin' ? 'active' : ''}`}
            onClick={() => setActiveTab('admin')}
            style={{
              color: activeTab === 'admin' ? '#0f172a' : '#38bdf8',
              background: activeTab === 'admin' ? '#38bdf8' : 'rgba(56, 189, 248, 0.12)',
              border: '1px solid rgba(56, 189, 248, 0.3)'
            }}
          >
            <Shield size={16} />
            <span>Administration</span>
          </button>
        )}

        <button
          className={`nav-tab ${activeTab === 'docs' ? 'active' : ''}`}
          onClick={() => setActiveTab('docs')}
        >
          <BookOpen size={16} />
          <span>Documentation</span>
        </button>
      </nav>

      {/* User Info & Logout on the right */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {impersonatedTenantName && (
          <div style={{
            background: 'rgba(245, 158, 11, 0.15)',
            border: '1px solid #f59e0b',
            color: '#f59e0b',
            padding: '3px 8px',
            borderRadius: '6px',
            fontSize: '0.72rem',
            fontWeight: '700',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <Building size={12} />
            <span>Vue : {impersonatedTenantName}</span>
            <button
              onClick={onClearImpersonate}
              style={{ background: 'none', border: 'none', color: '#f59e0b', cursor: 'pointer', fontWeight: '800' }}
              title="Quitter la vue impersonated"
            >
              ✕
            </button>
          </div>
        )}

        {currentUser && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: '#0f172a',
            border: '1px solid #334155',
            padding: '4px 10px',
            borderRadius: '8px',
            fontSize: '0.75rem'
          }}>
            <span style={{ color: '#cbd5e1', fontWeight: '600' }}>
              {currentUser.firstName || currentUser.email?.split('@')[0]}
            </span>
            <span style={{
              background: currentUser.role === 'admin' ? '#38bdf8' : '#334155',
              color: currentUser.role === 'admin' ? '#0f172a' : '#cbd5e1',
              padding: '1px 5px',
              borderRadius: '4px',
              fontSize: '0.65rem',
              fontWeight: '800'
            }}>
              {currentUser.role === 'admin' ? 'ADMIN' : (currentUser.tenantName || 'USER')}
            </span>

            <button
              onClick={onLogout}
              style={{
                background: 'none',
                border: 'none',
                color: '#94a3b8',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '2px',
                marginLeft: '4px'
              }}
              title="Se déconnecter"
            >
              <LogOut size={14} color="#ef4444" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

